var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"hide-header":"","hide-footer":"","no-close-on-esc":"","no-close-on-backdrop":"","centered":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('i',{class:[
		'error-icon',
		'text-warning',
		'd-block',
		'text-center',
		'mb-1',
		'fas fa-exclamation-triangle' ]}),_c('div',{staticClass:"error-message p-3"},[_vm._v(_vm._s(_vm.$t('storeIsUnavailableError')))])])}
var staticRenderFns = []

export { render, staticRenderFns }